import { Location } from 'vue-router';
import { Routes } from '@front-app/constants/routes';

export const eventLink = (eventId: string): Location => ({ name: Routes.EVENT, params: { eventId } });

export const userProfileLink = (userId: string): Location => ({ name: Routes.USER_PROFILE, params: { userId } });

export const discussionLink = (discussionId: string, groupId: string): string => `/app/fgmbgi.shtml?md=${discussionId}&hcgd=${groupId}`;

export const logoutLink = (url?: string): string => {
	const params = new URLSearchParams();
	if (url?.trim()) {
		params.append('url', url);
	}
	return `/app/logout.shtml?${params.toString()}`;
};
